import { render } from "./AddLocation.vue?vue&type=template&id=13953737"
import script from "../js/add-location.js?vue&type=script&lang=js"
export * from "../js/add-location.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__